"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFormContext = void 0;
const tslib_1 = require("tslib");
const components_1 = tslib_1.__importDefault(require("./components"));
const DataSchemaContext_1 = require("../core/DataSchemaContext");
const DataStub_1 = require("../core/DataStub");
// @ts-ignore   悲伤， typescript 不能默认导入 .vue 的...
const FieldLabel_1 = tslib_1.__importDefault(require("./FieldLabel"));
const ComponentManager_1 = require("../ui-core/ComponentManager");
/**
 * 在核心库的 DataSchemaContext 基础上，加了些 ui 相关的东西
 */
class DataFormContext extends DataSchemaContext_1.DataSchemaContext {
    constructor(root, opts) {
        super(root, opts);
        /** 编辑框组件大全 */
        this.components = new ComponentManager_1.ComponentManager();
        const opts2 = Object.assign(Object.assign({}, DataFormContext.defaults), opts || {});
        this.components.register(components_1.default);
        this.components.register(opts2.components);
        this.FieldLabel = opts2.FieldLabel;
        this.rootStub = DataStub_1.DataStub.fromRoot(this, opts === null || opts === void 0 ? void 0 : opts.initialValue);
    }
}
exports.DataFormContext = DataFormContext;
/** DataFormContext 的默认配置 */
DataFormContext.defaults = Object.assign(Object.assign({}, DataSchemaContext_1.DataSchemaContext.defaults), { components: [], FieldLabel: FieldLabel_1.default });
//# sourceMappingURL=DataFormContext.js.map